<template>
    <card title="Merge Patients Queue">
        <b-table :items="items" :fields="fields" empty-text="No items in the queue" :show-empty="!loading">
            <template #cell(created)="data">
                {{ data.item.createdBy }}
                <br>
                <small>
                    {{ formatCreatedDate(data.item) }}
                </small>
            </template>
            <template #cell(actions)="data">
                <div>
                    <b-button :to="{ name: 'MergePatientsPage', params: data.item }" size="sm" variant="primary" block>
                        Merge
                    </b-button>
                    <b-button size="sm" block @click="removeItem(data.item)">
                        Remove
                    </b-button>
                </div>
            </template>
            <template #cell(sourcePatientName)="data">
                {{ data.item.sourcePatientFirstName }}
                {{ data.item.sourcePatientLastName }}
            </template>
            <template #cell(targetPatientName)="data">
                {{ data.item.targetPatientFirstName }}
                {{ data.item.targetPatientLastName }}
            </template>
            <template #cell(sourcePatientId)="data">
                <router-link :to="{ name: 'PatientDashboard', params: { id: data.value } }">
                    {{ data.value }}
                </router-link>
            </template>
            <template #cell(targetPatientId)="data">
                <router-link :to="{ name: 'PatientDashboard', params: { id: data.value } }">
                    {{ data.value }}
                </router-link>
            </template>
            <template #cell(notes)="data">
                <small>{{ data.value }}</small>
            </template>
        </b-table>
    </card>
</template>

<script lang="ts">

import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import moment from "moment";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";

@Component({
    name: "MergePatientsPage",
    components: {}
})
export default class MergePatientsQueuePage extends Vue {

    private items = [];
    private loading = true;

    mounted() {
        this.getQueue();
    }

    get userCanMerge() {
        return this.$permissions.some(p => p.permissionCodeName.toLowerCase() === "Maintenance/Merge Patients".toLowerCase());
    }

    get fields() {
        const fields: Array<{ key: string, label?: string, class?: string }> = [
            { key: "sourcePatientId" },
            { key: "sourcePatientName" },
            { key: "targetPatientId" },
            { key: "targetPatientName" },
            { key: "notes" },
            { key: "created" }
        ];

        if (this.userCanMerge) {
            fields.push({ key: "actions", label: "", class: "actions" });
        }

        return fields;
    }

    async getQueue() {
        try {
            this.loading = true;
            const response = await axios.get("/patient/mergequeue");
            this.items = response.data;
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        } finally {
            this.loading = false;
        }
    }

    formatCreatedDate(value: any) {
        return (value.isTimeUtc ? moment.utc(value.created).local() : moment(value.created)).format("LLL");
    }

    async removeItem(queueItem: any) {
        try {
            let response = await this.$bvModal.msgBoxConfirm('Are you sure you want to remove this item from the merge queue?', {
                title: 'Confirm Remove from Merge Queue',
                okVariant: 'danger',
                centered: true,
                noFade: true
            });

            if (!response) return;

            response = await axios.delete(`/patient/mergequeue/${queueItem.id}`);

            this.items = response.data;
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

}


</script>

<style scoped lang="scss">
::v-deep(td.actions) {
    width: 150px;

    div {
        display: flex;
        gap: 6px;
        flex-direction: column;
    }
}
</style>
